import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useTitle } from '../hooks/use-title'
import { SHOW_SITE } from '../user/permission'
import { useSite } from '../site/hooks'

export const Route = createFileRoute('/_auth/_main/websites/$siteId')({
    beforeLoad: ({ context }) => {
        if (!context.auth.can(SHOW_SITE)) {
            throw redirect({ to: '/dashboard' })
        }
    },
    component: Website,
})

function Website() {
    const { siteId } = Route.useParams()
    const { t } = useTranslation()
    const { data: site } = useSite(siteId)

    useTitle(site?.name ?? t('Websites'))

    return <Outlet />
}
